import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Client-side redirect for testers who still visit the legacy Emergent
// hostnames. We can't set a true 301 at the platform level (per Emergent
// support, this must be requested via support@emergent.sh), but this
// runs before any React code and instantly hops them to the canonical
// custom domain so their bookmarked links keep working.
(function redirectLegacyHosts() {
  if (typeof window === "undefined") return;
  const legacyHosts = new Set([
    // Old *deployed* URL. NOTE: never include the ephemeral preview
    // (`author-beta-hub.preview.emergentagent.com`) here — the platform
    // uses it for dev/testing and we don't want a redirect loop during
    // development.
    "author-beta-hub.emergent.host",
  ]);
  if (legacyHosts.has(window.location.hostname)) {
    const target =
      "https://lastbookmark.com" +
      window.location.pathname +
      window.location.search +
      window.location.hash;
    window.location.replace(target);
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
